import { EventEmitter } from 'events';
import { flatMap, groupBy, throttle } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { IErrorDefinition, IErrorParams, IErrorReceiver, ILogParams } from './ErrorLogger.types';
import { reasonToString } from './utils';

export class ErrorLogger {
  private _inputEmitter: EventEmitter;
  private _throttledEventSource: any;

  constructor({ throttleTime = 3 * 1000 } = {}) {
    this._inputEmitter = new EventEmitter();
    this._throttledEventSource = fromEvent(this._inputEmitter, 'error').pipe(
      groupBy(
        ({ errorDefinition, reason }: IErrorParams) =>
          `${errorDefinition.id}-${errorDefinition.name}~${reasonToString(reason)}`,
      ),
      flatMap(throttle(() => Promise.resolve(throttleTime))),
    );
  }

  subscribe(receiver: IErrorReceiver) {
    this._throttledEventSource.subscribe(receiver);
    return this;
  }

  log(errorDefinition: IErrorDefinition, { reason, p1, p2, p3, p4 }: ILogParams = {}) {
    this._inputEmitter.emit('error', { errorDefinition, reason, p1, p2, p3, p4 });
  }

  createLoggingHandler(errorDefinition: IErrorDefinition, params?: ILogParams) {
    return (reason) => {
      this.log(errorDefinition, { reason, ...params });
      return Promise.reject(reason);
    };
  }
}
